<template>
  <v-form direction="horizontal" :model="qxForm" :rules="rules" ref="qxForm">
    <v-card title="权限维护">
      <div class="grid-demo">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="12">
            <div class="gutter-box">
              <v-form-item
                label="角色名称"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                prop="roleid"
              >
                <v-select
                  style="width: 250px"
                  dropdown-width="240px"
                  :data="role_options"
                  v-model="qxForm.js_id"
                  @change="change"
                ></v-select>
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </div>
      <div style="text-align: center">
        <v-button type="success" icon="save" @click.prevent="save('qxForm')"
          >保存</v-button
        >
        <v-button type="warning" icon="close-circle-o" @click="reset"
          >重置</v-button
        >
      </div>
     
      <div style="width: 33%; float: left">
        <v-card title="授权Web菜单" :bordered="false">
          <v-tree
            :data="menuData"
            ref="menutree"
            node-key="title"
            checkable
            multiple
            showLine
          ></v-tree>
        </v-card>
      </div>
      <div style="width: 33%; float: left">
        <v-card title="授权小程序菜单" :bordered="false">
          <v-tree
            :data="xcxMenuData"
            ref="xcxmenutree"
            node-key="title"
            checkable
            multiple
            showLine
          ></v-tree>
        </v-card>
      </div>
       <div style="margin-left:1%;width:33%;float:right">
        <v-card title="授权用户" :bordered="false">
          <v-tree :data="userData" ref="usertree" checkable multiple showLine></v-tree>
        </v-card>
      </div>
      <br />
    </v-card>
  </v-form>
</template>

<script>
let qxForm = { js_id: "", menu: [],xcxmenu:[] , user: []};
export default {
  data: () => ({
    qxForm,
    role_options: [],
    menuData: [],
    xcxMenuData:[],
    userData: [],
    rules: {
      
      js_id: [
        {
          required: true,
          message: "请选择角色！"
        }
      ]
    },
    labelCol: {
      span: 6
    },
    wrapperCol: {
      span: 14
    }
  }),
  created() {
    this.init_jsxx();
    this.init_menu("");
    this.init_xcxmenu("");
    this.init_user("");
  },
  methods: {
    init_jsxx() {
      this.$axios.get("api/system/qxgl/get-js-list").then(res => {
        let self = this;
        if (res.data.code == 200) {
          self.role_options = res.data.data.map(item => {
            return { value: item.id, label: item.js_mc };
          });
          //this.$message["success"](res.data.message);
        }else{
         this.$message["error"](res.data.message);
        }
      });
    },
    init_menu(rid) {
      this.$axios.get("api/system/qxgl/get-menu-list-tree?js_id="+rid).then(res => {
        if(res.data.code == 200){
          let self = this;
          self.menuData = res.data.data;
        }else{
          this.$message["error"](res.data.message);
        }
        
      });
    },
    init_xcxmenu(rid) {
      this.$axios.get("api/system/qxgl/get-xcx_menu-list-tree?js_id="+rid).then(res => {
        if(res.data.code == 200){
          let self = this;
          self.xcxMenuData = res.data.data;
        }else{
          this.$message["error"](res.data.message);
        }
        
      });
    },
    init_user(rid) {
      this.$axios.get("api/system/rywh/get-rywh-list-tree?js_id="+rid).then(res => {
        if(res.data.code == 200){
          let self = this;
          self.userData = res.data.data;
        }else{
          this.$message["error"](res.data.message);
        }
      });
    },
    change(val) {
      if (val) {
        this.init_menu(qxForm.js_id);
        this.init_xcxmenu(qxForm.js_id);
        this.init_user(qxForm.js_id);
      }
    
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          qxForm.menu = this.$refs.menutree.getCheckedNodes().map(item => {
            return { menuid: item.id };
          });
          let halfmenu = this.$refs.menutree.getHalfCheckedNodes().map(item => {
            return { menuid: item.id };
          });
          qxForm.menu = qxForm.menu.concat(halfmenu);
          qxForm.xcxmenu = this.$refs.xcxmenutree.getCheckedNodes().map(item => {
            return { menuid: item.id };
          });
          let halfxcxmenu = this.$refs.xcxmenutree.getHalfCheckedNodes().map(item => {
            return { menuid: item.id };
          });
          qxForm.xcxmenu = qxForm.xcxmenu.concat(halfxcxmenu);
          qxForm.user = this.$refs.usertree.getCheckedNodes().map(item => {
            return { userid: item.id , iscompany:item.iscompany};
          });
          
          this.$axios.post("api/system/qxgl/set-qx-list", qxForm).then(res => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
            } else {
              this.$message["error"](res.data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    reset() {
      this.init_menu("");
       this.init_xcxmenu("");
    }
    
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/qxgl/qxwh.vue